import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKey02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 9a7 7 0 1 1 6.06 6.937 14.332 14.332 0 0 0-.514-.063l-.01.01a8.942 8.942 0 0 0-.25.244l-5.11 5.11-.036.037a2.794 2.794 0 0 1-.51.43c-.178.11-.373.19-.577.24a2.795 2.795 0 0 1-.665.055h-1.82c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.022 2.022 0 0 1-.201-.77C2 19.93 2 19.684 2 19.432v-1.82c0-.19-.001-.43.055-.665.05-.204.13-.399.24-.578.126-.206.296-.375.43-.509l.036-.036 5.111-5.11c.126-.126.196-.197.245-.25l.008-.01-.003-.045c-.01-.103-.03-.244-.06-.469A7.056 7.056 0 0 1 8 9Zm7 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgKey02.displayName = 'Key02';
export default SvgKey02;
